(() => {
  if (window.__cardQuickCartInitialized) return;
  window.__cardQuickCartInitialized = true;

  const productJsonUrl = (href) => {
    const url = new URL(href, window.location.origin);
    url.search = '';
    url.hash = '';
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    return url.toString();
  };

  const loadVariant = async (button) => {
    if (button.dataset.variantId) return button.dataset.variantId;
    if (button._variantPromise) return button._variantPromise;

    button._variantPromise = fetch(productJsonUrl(button.dataset.productUrl), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
        return response.json();
      })
      .then((product) => {
        if (!Array.isArray(product.variants) || product.variants.length !== 1) {
          button.hidden = true;
          return null;
        }
        const variant = product.variants[0];
        if (!variant.available) {
          button.disabled = true;
          button.setAttribute('aria-label', `${button.dataset.productTitle || 'Product'} — sold out`);
          return null;
        }
        button.dataset.variantId = variant.id;
        return variant.id;
      })
      .catch(() => null)
      .finally(() => {
        button._variantPromise = null;
      });

    return button._variantPromise;
  };

  const addToCart = async (button) => {
    if (button.classList.contains('is-loading') || button.disabled) return;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const variantId = await loadVariant(button);
      if (!variantId) return;

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      }

      const config = {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData,
      };

      const response = await fetch(routes.cart_add_url, config);
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add to cart');

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'card-quick-cart',
          productVariantId: String(variantId),
          cartData: state,
        });
      }

      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(state);
        cart.classList.remove('is-empty');
      } else {
        window.location.href = routes.cart_url;
        return;
      }

      button.classList.add('is-added');
      button.setAttribute('aria-label', `${button.dataset.productTitle || 'Product'} added to cart`);
      setTimeout(() => {
        button.classList.remove('is-added');
        button.setAttribute('aria-label', `Add ${button.dataset.productTitle || 'product'} to cart`);
      }, 1400);
    } catch (error) {
      console.error(error);
      button.setAttribute('aria-label', 'Could not add to cart');
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  };

  const makeButton = (wrapper) => {
    if (wrapper.querySelector('[data-card-quick-cart]')) return;
    const info = wrapper.querySelector('.card > .card__content .card__information');
    const link = wrapper.querySelector('.card__heading a[href*="/products/"]');
    if (!info || !link) return;

    const title = link.textContent.trim();
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'card-quick-cart';
    button.dataset.cardQuickCart = '';
    button.dataset.productUrl = link.href;
    button.dataset.productTitle = title;
    button.setAttribute('aria-label', `Add ${title || 'product'} to cart`);
    button.innerHTML = '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M3.5 6.5h3.7l2.6 14.2h14.6l3.1-10.1H8.2"/><circle cx="12.2" cy="25.3" r="1.6"/><circle cx="23.3" cy="25.3" r="1.6"/></svg>';

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      addToCart(button);
    });
    button.addEventListener('pointerdown', (event) => event.stopPropagation());
    wrapper.addEventListener('mouseenter', () => loadVariant(button), { once: true, passive: true });
    info.appendChild(button);
  };

  const scan = (root = document) => root.querySelectorAll('.product-card-wrapper').forEach(makeButton);

  const start = () => {
    scan();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('.product-card-wrapper')) makeButton(node);
          scan(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
